import React from 'react';

export default (
  <svg
    height="20"
    width="17"
    style={{ margin: '8px auto 0px auto', display: 'block' }}
    viewBox="0 0 12 18"
  >
    <path
      fill="#7B7F83"
      d="M7 10.17l3.03-3.03a1 1 0 0 1 1.414 1.415L6.76 13.237a1 1 0 0 1-1.414 0L.556 8.446A1 1 0 1 1 1.97 7.032L5 10.062V1a1 1 0 1 1 2 0v9.17zm-4.05 7.04c-.474 0-.858-.447-.858-1 0-.552.384-1 .858-1h6.1c.473 0 .858.448.858 1 0 .553-.385 1-.859 1H2.95z"
    />
  </svg>
);
